<template>
  <div>
    <modal
      name="photoModal"
      :scrollable="true"
      delay="2000"
      width="100%"
      height="auto"
      style="z-index: 9998;"
      @closed="closeModal"
    >
      <div v-if="work!=null" :id="modalAreaPhotoId" class="modalArea">
        <div class="content clearfix">

          <section id="spotPhoto">
            <img :src="work.normalUrl" :alt="`${work.prefectures}${work.city}の写真`">
          </section><!-- /spotPhoto -->

          <div id="spotText">
            <section id="spotInfo" class="clearfix">
              <div class="spotIcon">
                <img src="/img/icon_100Photos.png" srcset="/img/icon_100Photos@2x.png 2x" alt="日本写真100景">
              </div><!-- /.spotIcon -->

              <h1>{{work.address}}</h1>
              <div class="spotLocation">
                <p class="photographer"><span class="spotInfoSub">撮影: </span>{{work.photographer}} <span v-if="work.spotInformations && work.spotInformations.awardType">[{{work.spotInformations.awardType}}]</span></p>
                <p class="latlon"><span class="spotInfoSub">経緯経度: </span>{{work.latitude}}, {{work.longitude}}</p>
              </div><!-- /info -->
            </section><!-- /spotInfo -->

            <div v-if="showSpotInfo">
              <section id="spotDetails" v-if="work.spotInformations && work.spotInformations.spotName1 && work.spotInformations.spotInfo1">
                <h2>周辺の観光スポット① {{work.spotInformations.spotName1}}</h2>
                <p style="white-space: pre-wrap;">{{work.spotInformations.spotInfo1}}</p>
                <p class="spotAddress" v-if="work.spotInformations && work.spotInformations.spotAddress1"><span class="spotDetailsSub">住所 : </span>{{work.spotInformations.spotAddress1}}</p>
                <p class="spotUrl" v-if="work.spotInformations && work.spotInformations.spotUrl1"><span class="spotDetailsSub">URL : </span><a :href="work.spotInformations.spotUrl1" target="_blank" style="color:white;word-break: break-all;">{{work.spotInformations.spotUrl1}}</a></p>
              </section><!-- /spotComment -->
              <section id="spotDetails" v-if="work.spotInformations && work.spotInformations.spotName2 && work.spotInformations.spotInfo2">
                <h2>周辺の観光スポット② {{work.spotInformations.spotName2}}</h2>
                <p style="white-space: pre-wrap;">{{work.spotInformations.spotInfo2}}</p>
                <p class="spotAddress" v-if="work.spotInformations && work.spotInformations.spotAddress2"><span class="spotDetailsSub">住所 : </span>{{work.spotInformations.spotAddress2}}</p>
                <p class="spotUrl" v-if="work.spotInformations && work.spotInformations.spotUrl2"><span class="spotDetailsSub">URL : </span><a :href="work.spotInformations.spotUrl2" target="_blank" style="color:white;word-break: break-all;">{{work.spotInformations.spotUrl2}}</a></p>
              </section><!-- /spotComment -->
              <section id="spotDetails" v-if="work.spotInformations && work.spotInformations.spotName3 && work.spotInformations.spotInfo3">
                <h2>周辺の観光スポット③ {{work.spotInformations.spotName3}}</h2>
                <p style="white-space: pre-wrap;">{{work.spotInformations.spotInfo3}}</p>
                <p class="spotAddress" v-if="work.spotInformations && work.spotInformations.spotAddress3"><span class="spotDetailsSub">住所 : </span>{{work.spotInformations.spotAddress3}}</p>
                <p class="spotUrl" v-if="work.spotInformations && work.spotInformations.spotUrl3"><span class="spotDetailsSub">URL : </span><a :href="work.spotInformations.spotUrl3" target="_blank" style="color:white;word-break: break-all;">{{work.spotInformations.spotUrl3}}</a></p>
              </section><!-- /spotComment -->
            </div>

            <section v-else id="spotDetails">
              こちらに撮影スポット付近の観光情報を掲載したい自治体の方は、お気軽にお問い合わせしてください。こちらのページ下部「入力フォーム」のその他お問合せからご連絡ください。<br/>
              お問い合わせ先：<a href="https://corporate.tokyocameraclub.com/contact/" target="_blank" style="color:white;word-break: break-all;">https://corporate.tokyocameraclub.com/contact/</a>
            </section><!-- /spotComment -->

          </div><!-- /spotText -->

        </div><!-- /content -->
      </div><!-- /modalArea -->
      <div v-if="open" class="closeModalBotton fade" @click="closeModal"><img src="/img/blank.gif"></div>
    </modal>
  </div>
</template>

<script>
import Config from '../concern/config'

export default {
  components: {
  },
  props: [
    'work',
    'open'
  ],
  data () {
    return {
    }
  },
  computed: {
    modalAreaPhotoId () {
      if (this.work !== null && this.work.height >= this.work.width) return 'modalAreaPhotoV'
      if (this.work !== null && this.work.height < this.work.width) return 'modalAreaPhotoH'
      return ''
    },
    showSpotInfo () {
      if (this.work.spotInformations && this.work.spotInformations.spotName1 && this.work.spotInformations.spotInfo1) return true
      if (this.work.spotInformations && this.work.spotInformations.spotName2 && this.work.spotInformations.spotInfo2) return true
      if (this.work.spotInformations && this.work.spotInformations.spotName3 && this.work.spotInformations.spotInfo3) return true
      return false
    }
  },
  methods: {
    closeModal () {
      this.$emit('update:open', false)
      this.$modal.hide('photoModal')
      const path = '/'
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
      document.title = '東京カメラ部 日本写真100景 ～日本は発見を待っている。～'
      const ogTitle = document.querySelector('meta[property="og:title"]')
      const metaDescription = document.querySelector('meta[name="description"]')
      const ogDescription = document.querySelector('meta[property="og:description"]')
      const ogImage = document.querySelector('meta[property="og:image"]')
      const ogUrl = document.querySelector('meta[property="og:url"]')
      if (ogTitle) ogTitle.setAttribute('content', Config.siteTitle)
      if (metaDescription) metaDescription.setAttribute('content', Config.siteDescription)
      if (ogDescription) ogDescription.setAttribute('content', Config.siteDescription)
      if (ogImage) ogImage.setAttribute('content', Config.siteOgImage)
      if (ogUrl) ogUrl.setAttribute('content', Config.siteUrl)
    }
  },
  watch: {
    open (val) {
      if (val) {
        this.$modal.show('photoModal')
      }
    }
  }
}
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.8) !important;
}
.vm--modal {
  background-color:rgba(0,0,0,0) !important;
}
.loading{
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
